import MessageOption from 'owa-message-option/lib/MessageOption';
import MarkAsReadOption from 'owa-mark-as-read-option/lib/MarkAsReadOption';
import ReadReceiptsOption from 'owa-read-receipts-option/lib/ReadReceiptsOption';
var handlingSubCategory = {
    key: 'handling',
    titleStringKey: 'optionSubcategory_handling',
    options: [MessageOption, MarkAsReadOption, ReadReceiptsOption],
};
export default handlingSubCategory;
//# sourceMappingURL=handlingSubCategory.js.map